import script from "./bi-tmpl-detail-101-5.vue?vue&type=script&lang=ts&setup=true"
export * from "./bi-tmpl-detail-101-5.vue?vue&type=script&lang=ts&setup=true"

import "./bi-tmpl-detail-101-5.vue?vue&type=style&index=0&id=0dd34d46&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd34d46"]])

export default __exports__